<template>
  <div id="MainLayout" class="row-offcanvas row-offcanvas-left">
    <nav class="sidebar-offcanvas sidebar">
      <a class="navbar-brand" href="#"><img :src="require('@/assets/images/logo-icon.svg')" class="m-auto d-block img-fluid" /></a>
      <b-nav class="flex-column align-self-end">
        <b-nav-item class="mx-auto" :active="routeName === 'Home'" to="/">
          <div class="pt-1"><font-awesome-icon icon="lungs" size="2x" /></div>
        </b-nav-item>
        <b-nav-item class="mx-auto" :active="routeName === 'HomeDateRange'" to="/ranged">
          <div class="pt-1"><font-awesome-icon icon="calendar-week" size="2x" /></div>
        </b-nav-item>
        <b-nav-item class="mx-auto" :active="routeName === 'HomeHistorical'" to="/historical">
          <div class="pt-1"><font-awesome-icon icon="chart-line" size="2x" /></div>
        </b-nav-item>
        <b-nav-item class="mx-auto" :active="routeName === 'HomeSystem'" to="/system">
          <div class="pt-1"><font-awesome-icon icon="clock" size="2x" /></div>
        </b-nav-item>
        <b-nav-item class="mx-auto" :active="routeName === 'HomeUptime'" to="/uptime">
          <div class="pt-1"><font-awesome-icon icon="server" size="2x" /></div>
        </b-nav-item>
        <b-nav-item class="mx-auto">
          <div class="pt-1"><font-awesome-icon icon="cog" size="2x" /></div>
        </b-nav-item>
      </b-nav>
      <b-nav class="flex-column bottom">
        <b-nav-item class="mx-auto" @click="doLogout()">
          <div class="pt-2">
            <font-awesome-icon icon="sign-out-alt" size="2x" />
            <span class="text">Logout</span>
          </div>
        </b-nav-item>
      </b-nav>
    </nav>
    <main role="main" class="main">
      <router-view/>
    </main>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  computed: {
    routeName () {
      console.log(this.$route.name)
      return this.$route.name
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    doLogout: function () {
      this.logout()
      this.$router.push('/login')
    }
  }
}
</script>
